import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Box, Paper } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 600,
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

export default function Welcome() {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="md" className={classes.container}>
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h3" className={classes.title}>
          Welcome to Collection Ninja
        </Typography>
        <Typography variant="h5" gutterBottom>
          Track Your Comic Book Collection
        </Typography>
        <Box className={classes.content}>
          <Typography variant="body1" paragraph>
            Collection Ninja helps you organize and manage your comic book collection with ease.
          </Typography>
          <Typography variant="body1" paragraph>
            • Browse and add your favorite Marvel heroes
          </Typography>
          <Typography variant="body1" paragraph>
            • Track comic series and individual issues
          </Typography>
          <Typography variant="body1" paragraph>
            • Keep track of which comics you own
          </Typography>
          <Typography variant="body1" paragraph>
            • Find missing issues in your collection
          </Typography>
          <Typography variant="body1" paragraph>
            • Quick entry for adding comics to your collection
          </Typography>
          <Box mt={3}>
            <Typography variant="body2" color="textSecondary" align="center">
              Sign in with Google or Email to get started!
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
